/* TK – doplnky na stránke Košík: Housing toggle, prepočet dane, gate na VOP */
(function () {
  var HOUSING_VARIANT = 58607455273334;

  function money(cents) {
    try {
      return new Intl.NumberFormat('sk-SK', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  }

  function refreshTotals() {
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var base = cart.total_price;
        var tax = Math.round((base * 23) / 100);
        var withTax = base + tax;
        var t = document.querySelector('.tk-cart-extras__tax-value');
        var w = document.querySelector('.tk-cart-extras__withtax-value');
        if (t) t.textContent = money(tax);
        if (w) w.textContent = money(withTax);
        var hasHousing = cart.items.some(function (i) { return i.variant_id === HOUSING_VARIANT; });
        var cb = document.querySelector('.tk-housing-toggle');
        if (cb) cb.checked = hasHousing;
      })
      .catch(function () {});
  }

  function reloadCartSections() {
    // po zmene Housing vždy plné načítanie – footer súčty aj položky sú tak isté
    window.location.reload();
  }

  function setHousing(add) {
    var spin = document.querySelector('.tk-housing-spinner');
    var cb = document.querySelector('.tk-housing-toggle');
    var err = document.querySelector('.tk-cart-extras__housing-error');
    if (spin) spin.hidden = false;
    if (cb) cb.disabled = true;
    if (err) err.hidden = true;

    var root = window.Shopify.routes.root;

    var fail = function (message) {
      if (spin) spin.hidden = true;
      if (cb) {
        cb.disabled = false;
        cb.checked = !add; // vráť checkbox do stavu pred kliknutím
      }
      if (err) {
        err.textContent = message || 'Housing sa nepodarilo pridať do košíka. Skúste to prosím znova.';
        err.hidden = false;
      }
    };

    var succeed = function () {
      if (spin) spin.hidden = true;
      if (cb) cb.disabled = false;
      refreshTotals();
      reloadCartSections();
    };

    if (add) {
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: HOUSING_VARIANT, quantity: 1 }] }),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || result.data.status) {
            fail(result.data && result.data.description);
            return;
          }
          succeed();
        })
        .catch(function () {
          fail();
        });
    } else {
      // odstránenie: nájdi riadok s Housing variantom a zmeň podľa jeho KEY (nie index/variant)
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = cart.items.filter(function (i) { return i.variant_id === HOUSING_VARIANT; })[0];
          if (!line) { succeed(); return; }
          return fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 }),
          }).then(function (r) {
            return r.json().then(function (data) {
              return { ok: r.ok, data: data };
            });
          });
        })
        .then(function (result) {
          if (result && (!result.ok || result.data.status)) {
            fail(result.data && result.data.description);
            return;
          }
          succeed();
        })
        .catch(function () {
          fail();
        });
    }
  }

  function bind() {
    var wrap = document.querySelector('.tk-cart-extras');
    if (!wrap || wrap.dataset.tkBound) return;
    wrap.dataset.tkBound = '1';

    var toggle = wrap.querySelector('.tk-housing-toggle');
    if (toggle) {
      toggle.addEventListener('change', function () {
        setHousing(toggle.checked);
      });
    }

    // Gate: bez súhlasu s VOP nepustiť do pokladne
    var form = document.getElementById('cart');
    var vop = wrap.querySelector('.tk-consent-vop');
    var err = wrap.querySelector('.tk-cart-extras__vop-error');
    if (form && vop) {
      form.addEventListener(
        'submit',
        function (e) {
          if (!vop.checked) {
            e.preventDefault();
            e.stopImmediatePropagation();
            if (err) err.hidden = false;
            wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        },
        true
      );
      vop.addEventListener('change', function () {
        if (vop.checked && err) err.hidden = true;
      });
    }

    refreshTotals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  // Dawn po zmene košíka prekresľuje sekcie – naviažeme znova
  document.addEventListener('cart:refresh', bind);
  document.addEventListener('cart:updated', function () {
    bind();
    refreshTotals();
  });
})();
